import Box from "@mui/material/Box";

import { zinc } from "./tokens";

export default function FilterSectionHeader({ title }: { title: string }) {
  return (
    <Box
      sx={{
        fontWeight: 700,
        px: 0.5,
        pb: 0.5,
        mb: 1,
        borderBottom: `1px solid ${zinc[500]}`,
      }}
    >
      {title}
    </Box>
  );
}
